import BaseEnum from "./base_enum.js";

class IdentityDocumentTypeEnumDesc extends BaseEnum {

  name() {
    return "identity_document_type";
  }

  rawValues() {
    return ["local_passport", "international_passport"];
  }

}

const IdentityDocumentTypeEnum = new IdentityDocumentTypeEnumDesc();
export default IdentityDocumentTypeEnum;